import Vue from "vue";
import Vuex from "vuex";

import sitesModule from "./store/sites";
import serversModule from "./store/servers";
import usersModule from "./store/users";
import projectsModule from "./store/projects";
import providersModule from "./store/providers";
import typesModule from "./store/types";
import maintenancesModule from "./store/maintenances";
import monitoringsModule from "./store/monitorings";
import employeesModule from "./store/employees";

Vue.use(Vuex);
import * as auth from "./api/auth";

export default new Vuex.Store({
  state: {
    title: "Heimdall",
    large: window.localStorage.getItem("large") == "true" || false,
    intervals: {},
    token: window.localStorage.getItem("token") || "",
    userId: window.localStorage.getItem("userId") || "",
    userName: window.localStorage.getItem("userName") || "",
    user: {},
    domain: window.localStorage.getItem("domain") || "",
    port: window.localStorage.getItem("port") || "",
    refresh: window.localStorage.getItem("refresh") || "",
    projectId: window.localStorage.getItem("projectId") || "",
    lang: window.localStorage.getItem("lang") || "fr",
    employeePwd: "",
    toastMessage: "",
    toastOpened: false,
    toastTimeout: null,
    toastMode: "",
    search: ""
  },
  getters: {
    getUserId: state => state.userId,
    getToken: state => state.token
  },
  mutations: {
    setTitle(state, title) {
      document.title = `${state.title} - ${title}`;
    },
    /* App layout */
    setupLarge(state) {
      window.localStorage.setItem("large", !state.large);
      state.large = !state.large;
    },
    /* Setup section */
    setupMonithor(state, { domain, port, refresh }) {
      window.localStorage.setItem("domain", domain);
      state.domain = domain;
      window.localStorage.setItem("port", port);
      state.port = port;
      window.localStorage.setItem("refresh", refresh);
      state.refresh = refresh;
      // Clear logs refresh interval
      clearInterval(state.intervals["sites"]);
      clearInterval(state.intervals["servers"]);
    },
    setLanguage(state, lang) {
      window.localStorage.setItem("lang", lang);
      state.lang = lang;
    },
    setEmployeePwd(state, pwd) {
      state.employeePwd = pwd;
    },
    /* Auth section */
    login(state, { user }) {
      window.localStorage.setItem("token", user.token);
      state.token = user.token;
      window.localStorage.setItem("userId", user.user.id);
      state.userId = user.user.id;
      window.localStorage.setItem("userName", user.user.name);
      state.userName = user.user.name;
      state.user = user.user;
    },
    logout(state) {
      window.localStorage.setItem("token", "");
      state.token = "";
      window.localStorage.setItem("userId", "");
      state.userId = "";
      window.localStorage.setItem("userName", "");
      state.userName = "";
      state.user = {};
      window.localStorage.setItem("projectId", "");
      state.projectId = "";
      state.employeePwd = "";
      // Clear logs refresh interval
      clearInterval(state.intervals["sites"]);
      clearInterval(state.intervals["servers"]);
    },
    /* Toast section */
    setOpenToast(state, { opened }) {
      state.toastOpened = opened;
    },
    setToastMessage(state, { message }) {
      state.toastMessage = message;
    },
    setToastMode(state, { mode }) {
      state.toastMode = mode || "notice";
    },
    setToastTimout(state, { timeout }) {
      state.toastTimeout = timeout;
    },
    clearToastTimout(state) {
      clearTimeout(state.toastTimeout);
      state.toastTimeout = null;
      state.toastMessage = "";
    },
    /* Dashboard */
    saveInterval(state, { name, interval }) {
      Vue.set(state.intervals, name, interval);
    },
    search(state, search) {
      state.search = search;
    },
    /* Project monitoring */
    setProject(state, projectId) {
      window.localStorage.setItem("projectId", projectId);
      state.projectId = projectId;
    }
  },
  actions: {
    setTitle({ commit }, title) {
      commit("setTitle", title);
    },
    /* App layout */
    setupLarge({ commit }) {
      commit("setupLarge");
    },
    /* Setup section */
    setupMonithor({ commit }, { domain, port, refresh }) {
      commit("setupMonithor", {
        domain,
        port,
        refresh
      });
    },
    setLanguage({ commit }, lang) {
      commit("setLanguage", lang);
    },
    setEmployeePwd({ commit }, pwd) {
      commit("setEmployeePwd", pwd);
    },
    /* Auth section */
    async login({ commit, dispatch }, { email, password }) {
      try {
        const user = await auth.login({ email, password });
        commit("login", {
          user
        });
        dispatch("setToastMessage", {
          message: "loginSuccessful"
        });
        dispatch("setToastMode", {
          mode: "notice"
        });
        dispatch("setOpenToast", {
          opened: true
        });
      } catch (error) {
        dispatch("setToastMessage", {
          message: "loginFailed"
        });
        dispatch("setToastMode", {
          mode: "error"
        });
        dispatch("setOpenToast", {
          opened: true
        });
      }
    },
    logout({ commit, dispatch }) {
      commit("logout");
      dispatch("setToastMessage", { message: "userLogout" });
      dispatch("setToastMode", { mode: "notice" });
      dispatch("setOpenToast", { opened: true });
    },
    /* Toast section */
    setOpenToast({ commit }, { opened }) {
      commit("setOpenToast", {
        opened
      });
    },
    setToastTimout({ commit }, { timeout }) {
      commit("setToastTimout", {
        timeout
      });
    },
    setToastMessage({ commit }, { message }) {
      commit("setToastMessage", {
        message
      });
    },
    setToastMode({ commit }, { mode }) {
      commit("setToastMode", {
        mode
      });
    },
    clearToastTimout({ commit }) {
      commit("clearToastTimout");
    },
    /* Dashboard */
    saveInterval({ commit }, { name, interval }) {
      commit("saveInterval", { name, interval });
    },
    search({ commit }, search) {
      commit("search", search);
    },
    /* Project monitoring */
    setProject({commit}, id) {
      commit("setProject", id);
    }
  },
  modules: {
    sitesState: sitesModule,
    serversState: serversModule,
    usersState: usersModule,
    projectsState: projectsModule,
    providersState: providersModule,
    typesState: typesModule,
    maintenancesState: maintenancesModule,
    monitoringsState: monitoringsModule,
    employeesState: employeesModule
  }
});
